const CLASS_SEARCH_ACTIVE = 'is-search-active';

const banner = document.getElementById( 'header-banner' );
const form = document.getElementById( 'header-search-form' );
const toggle = document.getElementById( 'search-toggle' );
const input = document.getElementById( 'search-input' );

// Keep track of the cursor to prevent the form from disappearing
// when the user hits the submit button...
let isFormHovered = false;

/**
 * Checks that the search toggle isn't currently
 * set to `display: none`
 */
const isSearchTogglePresent = () => !! toggle && toggle.offsetWidth > 0;

toggle?.addEventListener( 'click', () => input?.focus() );
input?.addEventListener( 'focus', () => {
	if ( isSearchTogglePresent() ) {
		banner?.setAttribute(
			'style',
			`min-height: ${ banner.offsetHeight }px`
		);
		banner?.classList.add( CLASS_SEARCH_ACTIVE );
	}
} );
input?.addEventListener( 'blur', () => {
	if ( ! isFormHovered ) {
		banner?.classList.remove( CLASS_SEARCH_ACTIVE );
		banner?.removeAttribute( 'style' );
	}
} );
form?.addEventListener( 'mouseenter', () => {
	isFormHovered = true;
} );
form?.addEventListener( 'mousemove', () => {
	isFormHovered = true;
} );
form?.addEventListener( 'mouseleave', () => {
	isFormHovered = false;
	if ( !! input && document.activeElement !== input ) {
		banner?.classList.remove( CLASS_SEARCH_ACTIVE );
	}
} );
